<template>
  <div class="send-processing">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item v-if="isHq && funcView.free_accessories_order_add_stock">
          <el-button type="primary" :disabled="!canAddOutStock" @click="showDelivery">{{ funcView.free_accessories_order_add_stock }}</el-button>
        </el-form-item>
        <el-form-item v-if="isHq && funcView.free_accessories_order_cancel">
          <el-button type="primary" :disabled="!canCancel" @click="showCancel">{{ funcView.free_accessories_order_cancel }}</el-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0" v-if="funcView.free_accessories_order_export">
          <el-button class="table-set" @click="exportTable">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right" :class="{ 'mr-0': !funcView.free_accessories_order_export }">
          <search-input v-model="formSearch.search" :placeholder="$t('crm_send_processing.ji_shen_hao')" @fetch="onSearch"></search-input>
        </el-form-item>
        <!-- 高级搜索 -->
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onSearch" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('crm_send_processing.chan_pin_xing_hao')">
          <custom-select url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('crm_send_processing.zeng_song_pei_jian')">
          <el-input v-model="formSearch.partCodeName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_send_processing.he_tong_bian_hao')">
          <el-input v-model="formSearch.contractNo"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_send_processing.shou_hou_gong_si')">
          <el-input v-model="formSearch.afterServiceName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_send_processing.que_ren_ri_qi')">
          <custom-date-picker
            style="width: 100%"
            @change="onPageChange({ page: 1 })"
            v-model="formSearch.confirmTime"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('crm_send_processing.qrskrq')">
          <custom-date-picker
            style="width: 100%"
            @change="onPageChange({ page: 1 })"
            v-model="formSearch.finalPayment"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('crm_send_processing.chuang_jian_ri_qi')">
          <custom-date-picker
            style="width: 100%"
            @change="onPageChange({ page: 1 })"
            v-model="formSearch.gmtCreate"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('crm_send_processing.xiang_mu_ming_cheng')">
          <el-input v-model="formSearch.locationName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_send_processing.cao_zuo_ren')">
          <el-input v-model="formSearch.modifier"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        tableCode="free_part_order_send_process"
        ref="table"
        v-model="tableSelect"
        type="checkbox"
        height="100%"
        :slots="['contractNo', 'orderGoodsCode', 'billTermNum']"
        :clickSelection="true"
        :data="tableList"
        @filter="filterChange"
        @sort="sortChange"
        @column="setColumn"
        @change="formatTableRow"
        @select="onTableSelect"
        @selectionAll="onSelectionAll"
      >
        <template v-slot:orderGoodsCode="scope">
          <span v-if="funcView.free_accessories_order_order_detail" class="cell-link" @click.stop="showDetail(scope.row)">{{ scope.row.orderGoodsCode }}</span>
          <span v-else>{{ scope.row.orderGoodsCode }}</span>
        </template>
        <template v-slot:contractNo="scope">
          <span class="cell-link" @click="toContractDetail(scope.row)">{{ scope.row.contractNo || '-' }}</span>
        </template>
        <template v-slot:billTermNum="scope">
          <div>
            {{ scope.row.billTermNum ? `${scope.row.billTermNum}/${scope.row.billTotalTerm}` : '-' }}
          </div>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <div class="table-sum-params">
        <div class="sum-item select-all">
          <el-checkbox v-model="isSelectAll" @change="onSelectAllChange">{{ $t('Common.com_sel_all') }}</el-checkbox>
        </div>
        <div class="sum-item">
          <div class="key">{{ $t('crm_send_processing.yi_xuan_zhong') }}</div>
          <div class="val selected-num">{{ selectedNum }}</div>
          <div class="key">{{ $t('crm_send_processing.xiang') }}</div>
          <div class="key">，</div>
        </div>
        <div class="sum-item">
          <div class="key">{{ $t('crm_send_processing.he_ji') }}：</div>
          <div class="val selected-num">{{ bookingNumTotal }}</div>
        </div>
        <div class="sum-item ml-10">
          <div class="key">{{ $t('crm_send_processing.zpjsl') }}：</div>
          <div class="val selected-num">{{ totalPartNum }}</div>
        </div>
      </div>
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <part-order-detail-dialog v-if="detailVisible" @close="detailVisible = false" :model="detailModel" @infoChange="getTableList"></part-order-detail-dialog>
    <cancel-dialog v-if="cancelVisible" :model="cancelModel" @close="cancelVisible = false" @confirm="onCancelConfirm"></cancel-dialog>
    <delivery-dialog v-if="deliveryVisible" @close="deliveryVisible = false" :model="deliveryModel" v-model="deliveryVisible" @success="getTableList"></delivery-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import partOrderDetailDialog from '@/pages/crm/components/part_order_detail_dialog.vue';
import cancelDialog from './cancel_dialog.vue';
// import replacePartDialog from './replace_part_dialog.vue';
import deliveryDialog from './delivery_dialog';
import mixins from './mixins.js';

export default {
  name: '',
  mixins: [mixins],
  components: {
    cancelDialog,
    deliveryDialog,
    partOrderDetailDialog,
  },
  props: {},
  data() {
    return {
      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,

        // 产品型号
        productCode: '',

        // 赠送配件
        partCodeName: '',

        // 合同编号
        contractNo: '',

        // 售后公司
        afterServiceName: '',

        // 创建日期
        confirmTime: '',
        // 最终支付日期
        finalPayment: '',
        // 创建日期
        gmtCreate: '',
        // 项目名称
        locationName: '',
        // 操作人
        operator: '',
      },
      link: null,

      tableList: [],
      tableSelect: [],
      // 是否勾选全部查询结果
      isSelectAll: false,
      // 全选过程中锁定，避免勾选过程误取消
      lockingSelectAll: false,

      totalRows: null,

      // 总配件数
      totalPartNum: 0,

      // 作废
      cancelVisible: false,
      cancelModel: {},

      // 更换配件
      replacePartVisible: false,
      replacePartModel: {},

      // 配送订单详情
      detailVisible: false,
      detailModel: {},

      // 新增出库单
      deliveryVisible: false,
      deliveryModel: {},
    };
  },
  computed: {
    // 是否可以 新增出库单
    canAddOutStock() {
      if (this.isSelectAll) {
        if (!this.tableList.length) {
          return false;
        }
        const firstId = this.tableList[0].afterServiceId;
        return this.tableList.every((item) => item.afterServiceId === firstId);
      }
      return this.isSameAfterService;
    },
    // 已选中数量，全选时展示全部查询结果数
    selectedNum() {
      return this.isSelectAll ? this.totalRows : this.tableSelect.length;
    },

    // 是否可以  作废
    canCancel() {
      return !this.isSelectAll && this.tableSelect.length === 1;
    },

    // 赠送数量合计
    bookingNumTotal() {
      if (this.isSelectAll) {
        return this.totalPartNum;
      }
      return this.tableSelect.reduce((total, obj) => total + (obj.bookingNum || 0), 0);
    },

    // 勾选的table row是否同一个售后公司 afterServiceName
    isSameAfterService() {
      if (this.tableSelect.length) {
        const map = {};
        this.tableSelect.forEach((item) => {
          map[item.afterServiceName] = 1;
        });
        return Object.keys(map).length === 1;
      }

      return false;
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    formatTableRow() {
      // 全选勾选过程中不处理，避免中途把全选状态冲掉
      if (this.lockingSelectAll) {
        return;
      }
      if (this.isSelectAll) {
        this.tableList.forEach((item) => {
          this.$set(item, 'isExists', false);
        });
        return;
      }
      const row = this.tableSelect[0];
      this.tableList.forEach((item) => {
        this.$set(item, 'isExists', row ? item.afterServiceId !== row.afterServiceId : false);
      });
    },
    // 查询时取消全选
    onSearch() {
      this.isSelectAll = false;
      this.onPageChange({ page: 1 });
    },
    // 根据当前勾选结果同步全选框
    syncSelectAll(selection) {
      if (this.lockingSelectAll) {
        return;
      }
      const selected = selection || this.tableSelect;
      const totalRows = Number(this.totalRows) || 0;
      const currentPageSelected = this.tableList.length > 0 && selected.length === this.tableList.length;
      // 当前勾选数量等于全部查询结果时，勾上全选
      if (totalRows > 0 && (selected.length === totalRows || (currentPageSelected && totalRows === this.tableList.length))) {
        this.isSelectAll = true;
        return;
      }
      // 当前页没有全部勾上，说明用户取消了部分行
      if (selected.length !== this.tableList.length) {
        this.isSelectAll = false;
      }
    },
    // 手动勾选某一行时同步全选
    onTableSelect(selection) {
      this.syncSelectAll(selection);
    },
    // 表头全选时同步底部全选
    onSelectionAll(selection) {
      this.syncSelectAll(selection);
    },
    // 勾选全部查询结果
    onSelectAllChange(val) {
      this.lockingSelectAll = true;
      this.isSelectAll = !!val;
      if (val) {
        this.tableList.forEach((item) => {
          this.$set(item, 'isExists', false);
        });
        this.selectCurrentPageAll();
      } else {
        this.$refs.table.$emit('clearSelection');
        this.$nextTick(() => {
          this.lockingSelectAll = false;
        });
      }
    },
    // 勾选当前页全部行
    selectCurrentPageAll() {
      this.$nextTick(() => {
        this.tableList.forEach((item) => {
          this.$refs.table.$emit('toggleRowSelection', item, true);
        });
        setTimeout(() => {
          this.isSelectAll = true;
          this.lockingSelectAll = false;
        }, 0);
      });
    },
    onCancelConfirm() {
      this.getTableList();
    },
    // 新增出库单
    showDelivery() {
      const isSelectAll = this.isSelectAll || (this.totalRows > 0 && this.tableSelect.length === this.totalRows);
      this.deliveryModel = {
        title: this.$t('crm_send_processing.xin_zeng_chu_ku_dan'),
        data: this.tableSelect.length ? this.tableSelect : this.tableList,
        isSelectAll,
        searchParams: this.getReqData(),
        totalPartNum: this.totalPartNum,
      };
      this.deliveryVisible = true;
    },
    // 作废
    showCancel() {
      this.cancelModel = {
        title: this.$t('crm_send_processing.zuo_fei'),
        data: this.tableSelect,
      };
      this.cancelVisible = true;
    },
    getReqData() {
      const { confirmTime } = this.formSearch;
      const reqData = { ...this.formSearch };
      if (confirmTime && confirmTime.length) {
        reqData.confirmStartTime = confirmTime[0];
        reqData.confirmEndTime = confirmTime[1];
      }
      delete reqData.confirmTime;
      const { finalPayment } = this.formSearch;
      if (finalPayment && finalPayment.length) {
        reqData.finalPaymentStartTime = finalPayment[0];
        reqData.finalPaymentEndTime = finalPayment[1];
      }
      delete reqData.finalPayment;
      const { gmtCreate } = this.formSearch;
      if (gmtCreate && gmtCreate.length) {
        reqData.createStartTime = gmtCreate[0];
        reqData.createEndTime = gmtCreate[1];
      }
      delete reqData.gmtCreate;
      return reqData;
    },

    getTableList() {
      const reqData = this.getReqData();
      this.$getJSON(apis.giveawayPage, reqData).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
        if (this.isSelectAll) {
          this.lockingSelectAll = true;
          this.formatTableRow();
          this.selectCurrentPageAll();
        } else {
          this.formatTableRow();
        }
      });
      this.$getJSON(apis.giveawayCount, reqData).then((res) => {
        this.totalPartNum = res.data || 0;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    clearFilter: function () {
      this.$refs.table.clearFilter();
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.isSelectAll = false;
      this.onPageChange({ page: 1 });
    },
    // 配送订单详情
    showDetail(row) {
      this.detailModel = {
        title: row.orderGoodsCode,
        data: row,
      };
      this.detailVisible = true;
    },
    exportTable() {
      const data = this.getReqData();
      delete data.pageNum;
      delete data.pageSize;

      this.$exportFlie(apis.giveawayExport, data).catch(() => {
        this.$message({
          message: this.$t('crm_send_processing.cao_zuo_shi_bai'),
          type: 'error',
        });
      });
    },
  },
  created() {},
  mounted() {
    // 应收账单查看赠送配件
    if (this.getJump('action') === 'view') {
      const orderGoodsCode = this.getJump('orderGoodsCode');
      const orderGiveawayId = this.getJump('orderGiveawayId');
      this.detailModel = {
        title: orderGoodsCode,
        data: { orderGoodsCode, orderGiveawayId },
      };
      this.detailVisible = true;
      // 改成已读 以防频发弹框
      this.$router.replace({
        query: {
          ...this.$route.query, // 保留其他查询参数
          action: 'viewed', // 修改 action 参数
        },
      });
    }
    // giveaway_biz_state
    this.getDicMap('giveaway_biz_state', () => {
      this.formSearch.type = this.dicMap.giveaway_biz_state.confirmed;
      this.resetFormSearch = JSON.stringify(this.formSearch);
      this.getFuncView(null, () => {
        setTimeout(() => {
          this.link = this.$refs.container;
        }, 500);
      });

      this.getTableList();
    });

    // this.showDetail();
  },
};
</script>

<style lang="scss" scoped>
.send-processing {
  flex: 1;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.table-sum-params {
  float: left;
  overflow: hidden;

  .selected-num {
    padding: 0 5px;
    color: #0d9ae0;
  }

  .sum,
  .price {
    color: #0d9ae0;
  }

  .ml-10 {
    margin-left: 10px;
  }

  .select-all {
    margin-right: 12px;
  }

  .sum-item {
    float: left;
    line-height: 32px;
    font-size: 12px;
    color: #606266;

    .key,
    .val {
      float: left;
    }
  }
}

.popup-content {
  .item {
    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }
}
</style>
